import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header, { AnnouncementBar } from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

export const SiteLayout = () => (
  <div className="flex min-h-screen flex-col bg-cream">
    <ScrollToTop />
    <AnnouncementBar />
    <Header />
    <main id="main" className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

export default SiteLayout;
